import { render, staticRenderFns } from "./HospitalTab.vue?vue&type=template&id=28b7393a&scoped=true&"
import script from "./HospitalTab.vue?vue&type=script&lang=js&"
export * from "./HospitalTab.vue?vue&type=script&lang=js&"
import style0 from "./HospitalTab.vue?vue&type=style&index=0&id=28b7393a&prod&lang=css&"
import style1 from "./HospitalTab.vue?vue&type=style&index=1&id=28b7393a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7393a",
  null
  
)

export default component.exports